// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__35BxO","inner":"Form_inner__p1Xdo","range":"Form_range__t9kQd","name":"Form_name__zlJrW","actions":"Form_actions__QzQDr"};